const ProductType = {
  PRODUCT: '产品',
  MATERIAL: '原料'
}
const MakeStatus={
  NEW:10,
  CHECKED:13,
  DOING:20,
  COMPLETED:30,
}

const MakeStatusLabel={
  10:'计划中',
  13:'已确认',
  20:'生产中',
  30:'已完成',
}
 const auditStatus = {
  10: '已提交',
  15: '审核中',
  20: '已通过',
  30: '已驳回'
}
const auditStatusColorMap = {
  10: 'primary',
  15: 'warning',
  20: 'success',
  30: 'danger'
}
const orderStatus = {
  'NEW':10,
  'DOING':20,
  'COMPLETED':200
}
const orderStatusLabel = {
  10: '新建',
  20: '进行中',
  200: '已完成'
}

export  const roleKeys={
  CompanyAdmin:'1497144338753867777',
  Business:'1517372315286491137',
  FINANCE:'1539452125610864642',
  Company:'1691365723202039809',
}

const D = {
  ProductType: ProductType,
  MakeStatus:MakeStatus,
  MakeStatusLabel:MakeStatusLabel,
  auditStatus:auditStatus,
  roleKeys:roleKeys,
  orderStatus:orderStatus,
  orderStatusLabel:orderStatusLabel,
  auditStatusColorMap
}

export default D
